import { render } from "./security-settings.vue?vue&type=template&id=5e728d1b&scoped=true"
import script from "./security-settings.js?vue&type=script&lang=js&external"
export * from "./security-settings.js?vue&type=script&lang=js&external"

import "./security-settings.css?vue&type=style&index=0&id=5e728d1b&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e728d1b"]])

export default __exports__